module.exports = __webpack_public_path__ + "static/media/Estate Alden King Headboard - 180 cm_White.0f575078.png";